module.exports = __webpack_public_path__ + "static/img/5.60cca98.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/sp/5.png
// module id = Gjjq
// module chunks = 0